import { writable } from 'svelte/store';

const initialDarkMode = typeof window !== 'undefined' 
  ? localStorage.getItem('darkMode') === 'true' || 
    (!localStorage.getItem('darkMode') && window.matchMedia('(prefers-color-scheme: dark)').matches)
  : false;

export const darkMode = writable(initialDarkMode);

if (typeof window !== 'undefined') {
  darkMode.subscribe(value => {
    localStorage.setItem('darkMode', String(value));
  });
}